const enum ConsumerLoanAuthenticationScope {
    DK = 'cl-DK',
    FI = 'cl-FI',
    NO = 'cl-NO',
    SE = 'cl-SE',
}

export default ConsumerLoanAuthenticationScope;
